module.exports = __webpack_public_path__ + "img/add.c9b69a2e.svg";